import React from 'react';
import PropTypes from 'prop-types';
import VaRadioField from 'platform/forms-system/src/js/web-component-fields/VaRadioField';

// OTHER is a submission dead-end, so hide it when editing on the review page.
export default function ClaimantRelationshipRadioField(props) {
  const onReviewPage = props?.childrenProps?.formContext?.onReviewPage;

  if (onReviewPage) {
    const { enum: enumValues = [], ...restSchema } = props.childrenProps.schema;
    const filteredProps = {
      ...props,
      childrenProps: {
        ...props.childrenProps,
        schema: { ...restSchema, enum: enumValues.filter(v => v !== 'OTHER') },
      },
    };
    return <VaRadioField {...filteredProps} />;
  }

  return <VaRadioField {...props} />;
}

ClaimantRelationshipRadioField.propTypes = {
  childrenProps: PropTypes.shape({
    schema: PropTypes.shape({
      enum: PropTypes.array,
    }),
    formContext: PropTypes.shape({
      onReviewPage: PropTypes.bool,
    }),
  }),
};
